import type { PlanOption } from "@/features/planSelection/models/PlanOption";
import { PlanOrderItemDto } from "@@@/dto/planSelection/PlanOrderItemDto";
import { useDomainSelectionStore } from "@/features/domain-checker-input/stores/useDomainSelectionStore";

export function buildPlanData(selectedPlans: PlanOption[], billingInterval: "monthly" | "yearly", paymentMethod: string): {
    products: PlanOrderItemDto[];
    paymentMethod: string;
    sendEmail: boolean;
    noEmail: boolean;
} {
    const domainStore = useDomainSelectionStore();
    const selectedDomainName = domainStore.domainName;

    // Filter out domain_managed (WHMCS Product ID 99) if domain is attached to hosting
    // Also filter out plans with null whmcsProductId
    const filteredPlans = selectedPlans.filter(plan => {
        if (!plan.whmcsProductId) return false;
        if (selectedDomainName && plan.id === 'domain_managed') return false;
        return true;
    });

    const products = filteredPlans.map((plan) => {
        let websiteDomain = plan.domain || "no-domain-specified.nl";

        // Attach the selected domain name to hosting packages
        if (selectedDomainName && (plan.id === 'webHosting_total' || plan.id === 'webHosting_pro')) {
            websiteDomain = selectedDomainName;
        }

        const item: PlanOrderItemDto = {
            whmcsProductId: plan.whmcsProductId!,
            billingCycle: billingInterval,
            domainType: domainStore.domainType,
            domain: websiteDomain
        };

        return item;
    });

    // Remove domain package with whmcsProductId 99 before sending to API
    const finalProducts = products.filter(product => product.whmcsProductId !== 99);

    const result = {
        products: finalProducts,
        paymentMethod,
        sendEmail: false,
        noEmail: true,
    };

    return result;
}
